import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/line-down.svg";
var LineDownOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  LineDownOutline_default as default
};
